import { useEffect, useState } from "react";
import AuthComp from "../component/AuthComp";
import { Form, Button, Alert } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from 'react-router-dom';
import ApiUtil from "../util/ApiUtil";
import ApiPath from "../util/ApiPath";
import Swal from 'sweetalert2'
import ListGroup from "../component/ListGroup";
import ReactLoading from "react-loading";

function LinkDriver() {
    const location = useLocation();
    const { state } = location;
    const { t } = useTranslation(); // Use t instead of lang
    const [validated, setValidated] = useState(false);
    const [selectedOperationName, setSelectedOperationName] = useState("")
    const [operationName, setOperationName] = useState([]);
    const state_data_id = state?.data.Id;
    const state_data_name = state?.data.DriverNameEn
    const [selectedDriverName, setSelectedDriverName] = useState(state_data_id ? state_data_id : "")
    const [driverName, setDriverName] = useState([])
    const [msgError, setMsgError] = useState('')
  const [loadingSubmit, setLoadingSubmit] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (event) => {
        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        setValidated(true);
        if (selectedDriverName && selectedOperationName) {
            setLoadingSubmit(true);
            let data = {
                "DriverId": selectedDriverName,
                "OperationId": selectedOperationName
            }
            const res = await ApiUtil.postApi(ApiPath.CONNECT_DRIVER_WITH_OPERATIONS, data, 'POST')
            if (res.IsSuccessfull) {
                Swal.fire({
                    icon: "success",
                    text: t('Connect driver with operations successfully'),
                    showConfirmButton: false,
                    timer: 4000
                });
                setLoadingSubmit(false);
                setTimeout(() => {
                    navigate('/driver-list', );
                }, 4500)
            } else {
                setMsgError(res.Errors[0].Message)
            }
        }
    };

    const getOperationApi = async () => {
        let data = {
            "OrderBy": "Id Desc",
            "UsersView": {
                "Role": 'OPERATION'
            }
        }
        const res = await ApiUtil.postApi(ApiPath.GET_ALL_USER, data, 'POST');
        if (res.IsSuccessfull) {
            setOperationName(res.Result.Users)
        }
    }
    const getDriverApi = async () => {
        let data = {
            "OrderBy": "Id Desc",
            "DriversView": {
                "StatusCode": "ACTIVE",
                "OperationId":null
            }
        }
        const res = await ApiUtil.postApi(ApiPath.GET_ALL_DRIVERS, data, 'POST');
        if (res.IsSuccessfull) {
            setDriverName(res.Result.Driver)
        }
    }

    useEffect(() => {
        getOperationApi();
        getDriverApi();
    }, [])

    return (
        <>
            <ListGroup />
            <AuthComp page="LinkDriver" arrowBack={false}>
                <Form noValidate validated={validated} onSubmit={handleSubmit}>
                    {/* selectedDriverName */}
                    <Form.Group controlId="DriverName">
                        <Form.Select className={selectedDriverName === "" && "first-select-color"}
                            onChange={(e) => setSelectedDriverName(e.target.value)}
                            required>
                            <option value={selectedDriverName ? selectedDriverName : ""} className="first-select-color">{state_data_name ? state_data_name : t("Driver name")}</option>
                            {driverName.map((item, index) => {
                                return item.OperationId === null && <option className="option-color" key={index} value={item.Id} >{item.DriverNameEn}</option>;
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            {t("Please Select Driver name")}
                        </Form.Control.Feedback>
                    </Form.Group>

                    {/* selectedOperation */}
                    <Form.Group controlId="OperationName" className="pt-3">
                        <Form.Select className={selectedOperationName === "" && "first-select-color"}
                            onChange={(e) => setSelectedOperationName(e.target.value)}
                            required>
                            <option value="" className="first-select-color">{t("Operation name")}</option>
                            {operationName.map((item, index) => {
                                return <option className="option-color" key={index} value={item.Id} >{item.FirstName + ' ' + item.LastName}</option>;
                            })}
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                            {t("Please Select Operation name")}
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Button aria-label="Aria label" type="submit" className="btn-main w-100 mt-4 " disabled={loadingSubmit}
          >
            <div className="flex-gap-2 justify-content-center">
              {t("Link")}
              {loadingSubmit && (
                <ReactLoading
                  type={"spin"}
                  color={"#c8c8c8"}
                  height={"20px"}
                  width={"20px"}
                />
              )}
            </div></Button>
                    {msgError !== '' && <Alert variant={'danger'} className="mt-3 py-2">{t(msgError)}</Alert>}

                </Form>
            </AuthComp>
        </>

    );
}

export default LinkDriver;
